/**
 * Slouží k otevírání/zavírání elementů s třídou .js-closableEl
 */
const initClosableElms = () => {
	const closableElms = Array.prototype.slice.call(
		document.querySelectorAll('.js-closableEl'),
	);

	closableElms.forEach((el) => {
		const closeBtn = el.querySelector('.js-closeEl');

		if (!closeBtn) {
			return;
		}

		closeBtn.addEventListener('click', () => {
			el.classList.remove('is-visible');
			el.classList.add('is-hidden');
		});
	});

	const openBtns = Array.prototype.slice.call(
		document.querySelectorAll('.js-openEl'),
	);

	openBtns.forEach((btn) => {
		btn.addEventListener('click', () => {
			const el = document.querySelector(`#${btn.dataset.id}`);

			if (!el) {
				return;
			}

			closableElms.forEach((div) => {
				div.classList.remove('is-visible');
				div.classList.add('is-hidden');
			});

			el.classList.add('is-visible');
			el.classList.remove('is-hidden');
		});
	});
};

export default initClosableElms;
